import React from "react";
import "./AllYourInvestments.css";
import image1 from "./website_homepage_cryptocurrencies.webp";
import image2 from "./website_homepage_metals.webp";
import image3 from "./website_homepage_stocks.webp";
import image4 from "./website_homepage_etfs.webp";
import image5 from "./website_homepage_commodities.webp";
import image6 from "./website_homepage_crypto-indices.webp";
const AllYourInvestments = () => {
  return (
    <>
      <section className="container">
        <section className="all-your-investment-section">
          <div className="all-your-investment-header">
            <h5>All your investments. All on WLF Finance. Instant access to investing, anytime and anywhere. Investing has never been easier. Everything you are looking for in an ultimate investment platform — on the device of your choice.</h5>
          </div>
          <div className="all-your-investment-card">
            <div className="all-your-investment-card-item">
              <div className="all-your-investment-text-container">
                <h3>Cryptocurrencies</h3>
                <p>
                  Buy, sell, and swap the cryptocurrencies you want anytime,
                  anywhere.
                </p>
              </div>
              <img src={image1} alt="" />
            </div>
            <div className="all-your-investment-card-item">
              <div className="all-your-investment-text-container">
                <h3>Precious Metals</h3>
                <p>
                  Diversify your portfolio by investing in physically-backed precious metals.
                </p>
              </div>
              <img src={image2} alt="" />
            </div>
            <div className="all-your-investment-card-item">
              <div className="all-your-investment-text-container">
                <h3>Stocks*</h3>
                <p>
                  Invest in fractions of your favourite companies without buying a full share.
                </p>
              </div>
              <img src={image3} alt="" />
            </div>
            <div className="all-your-investment-card-item">
              <div className="all-your-investment-text-container">
                <h3>ETFs*</h3>
                <p>
                 Invest in fractions of your favourite ETFs* without buying a full share.
                </p>
              </div>
              <img src={image4} alt="" />
            </div>
            <div className="all-your-investment-card-item">
              <div className="all-your-investment-text-container">
                <h3>Commodities*</h3>
                <p>
                 Fortify your portfolio with commodities* and shield it against inflation.
                </p>
              </div>
              <img src={image5} alt="" />
            </div>
            <div className="all-your-investment-card-item">
              <div className="all-your-investment-text-container">
                <h3>Crypto Indices</h3>
                <p>
                  Auto-invest in the whole crypto market with a single click.
                </p>
              </div>
              <img src={image6} alt="" />
            </div>
          </div>
        </section>
      </section>
    </>
  );
};

export default AllYourInvestments;
